import { Modal } from "ant-design-vue";
import lodash from "lodash";
import moment from "moment";
import { setIsLoading as setIsLoadingApp } from "../../../../app.logic";
import {
    createFieldDate,
    createFieldInput,
    createFieldSelect,
    createFieldTextArea
} from "../../../../components/input/template-builder/template-builder.logic";
import {
    createColumnDate,
    createColumnDatetime,
    createColumnInput,
    createColumnSelect
} from "../../../../components/table/c-table.logic";
import i18n from "../../../../i18n";
import router from "../../../../router";
import store from "../../../../store";
import { conditionFormChecker, copyForm, putField } from "../../../../utils/form";
import { callRequestStatus, callRequestType } from "../../storage-location/request/request.section";
import { callUser, checkUserCompanyOperation } from "../../storage-location/request/requestor/requestor.section";
import { callCountry, callHazObject, callHazType, clearSubStanceMain } from "./haz-info/haz-info.section";
import { defineAsyncComponent } from "vue";
import { dateFormat } from "../../../../utils/date";

const CIcon = defineAsyncComponent(() => import("../../../../components/icon/CIcon"));

export const callFilterHazDataExpired = ({ data }) => store.dispatch('resource/v1/transaction/haz/delHazsExpire', { data });
export const callHazAttachment = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "HAZ_ATTACHMENT", value: searchQuery });
export const callUserObjective = ({ searchQuery }) =>
    store
        .dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "USER_OBJECTIVE", value: searchQuery })
        .then(items => items.filter(item => ["1", "4"].includes(item.key)));
export const callHazReserveWord = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "HAZ_RESERVE_WORD", value: searchQuery });
export const callHaz = ({ searchQuery, userInfo, isOfficerCreate, expireDate, requestTypeKey }) => {
    const where = [
        { name: "isActive", type: "Boolean", operator: "=", value: true },
        { name: "isTemp", type: "Boolean", operator: "=", value: false },
        { name: "refStatus.key", type: "String", operator: "=", value: "complete" },
    ];

    if (requestTypeKey === "3") {
        where.push({ name: "expireDate", type: "Date", operator: "<=", value: expireDate ? expireDate : moment().add(3, "months").format("YYYY-MM-DD") })
    } else {
        where.push({ name: "expireDate", type: "Date", operator: ">=", value: moment().format("YYYY-MM-DD") })
    }

    if (!isOfficerCreate) {
        where.push(
            { openBucket: true, constant: true, name: "1", type: "String", operator: "=", value: "1" }, // 1
            { name: "refUserCompany.id", type: "UUID", operator: "=", value: userInfo?.refParent?.id || userInfo?.id },

            { logic: "OR", openBucket: true, constant: true, name: "1", type: "String", operator: "=", value: "1" }, // 2
            { name: "refUserCompany.userAuthorizes.isActive", type: "Boolean", operator: "=", value: true },
            { name: "refUserCompany.userAuthorizes.isTemp", type: "Boolean", operator: "=", value: false },
            { name: "refUserCompany.userAuthorizes.refStatus.key", type: "String", operator: "=", value: "active" },
            { name: "refUserCompany.userAuthorizes.refAuthorizeType.key", type: "String", operator: "=", value: "2" },
            { name: "refUserCompany.userAuthorizes.refAuthorize.id", type: "UUID", operator: "=", value: userInfo?.refParent?.id || userInfo?.id },

            { name: "refUserCompany.userAuthorizes.refAuthorize.userAuthorizes.isActive", type: "Boolean", operator: "=", value: true },
            { name: "refUserCompany.userAuthorizes.refAuthorize.userAuthorizes.isTemp", type: "Boolean", operator: "=", value: false },
            { name: "refUserCompany.userAuthorizes.refAuthorize.userAuthorizes.refStatus.key", type: "String", operator: "=", value: "active" },
            { name: "refUserCompany.userAuthorizes.refAuthorize.userAuthorizes.refAuthorizeType.key", type: "String", operator: "=", value: "1" },
            {
                name: "refUserCompany.userAuthorizes.refAuthorize.userAuthorizes.refAuthorize.id",
                type: "Getpath",
                operator: "=",
                value: "refUserCompany.id"
            },
            { closeBucket: true, constant: true, name: "1", type: "String", operator: "=", value: "1" }, // 2
            { closeBucket: true, constant: true, name: "1", type: "String", operator: "=", value: "1" } // 1
        );
    }
    if (searchQuery) {
        where.push({ name: "approveCode", type: "String", operator: "like", value: searchQuery });
    }
    return store
        .dispatch("resource/v1/transaction/haz/search", {
            criteria: {
                isDistinct: true,
                select: ["id", "approveCode", "refUserCompany.id", "refUserCompany.fullNameTh", "tradeNameTh", "expireDate"],
                page: 0,
                size: 1000000,
                where,
                sort: [{ name: "approveCode", type: "DESC" }]
            }
        })
        .then(page => page.data);
};
export const callHazFull = ({ id }) => {
    return store
        .dispatch("resource/v1/transaction/haz/search", {
            criteria: {
                select: ["**", "refUserCompany.refPersonType.*", "refUser.refPersonType.*", "refHazObject.**"],
                page: 0,
                size: 1,
                where: [{ name: "id", type: "UUID", operator: "=", value: id }],
                children: [
                    {
                        name: "refUserCompany.addresses",
                        select: ["*"],
                        page: 0,
                        size: 1,
                        where: [{ name: "refAddressType.key", type: "String", operator: "=", value: "1" }]
                    },
                    {
                        name: "refUser.addresses",
                        select: ["*"],
                        page: 0,
                        size: 1,
                        where: [{ name: "refAddressType.key", type: "String", operator: "=", value: "1" }]
                    },
                    {
                        name: "products",
                        select: ["*", "refProduct.*"],
                        page: 0,
                        size: 1000000,
                        sort: [{ name: "createDate", type: "ASC" }]
                    },
                    {
                        name: "mainSubStances",
                        select: ["**", "refSubStance.**"],
                        page: 0,
                        size: 1000000,
                        sort: [{ name: "createDate", type: "ASC" }],
                        children: [
                            {
                                name: "companies",
                                select: ["*", "refUserCompany.**"],
                                page: 0,
                                size: 1000000
                            },
                            {
                                name: "products",
                                select: ["*", "refHaz.**"],
                                page: 0,
                                size: 1000000
                            },
                            {
                                name: "attachments",
                                select: ["*"],
                                page: 0,
                                size: 1000000
                            }
                        ]
                    },
                    {
                        name: "pictograms",
                        select: ["*", "refPictogram.**"],
                        page: 0,
                        size: 1000000,
                        sort: [{ name: "createDate", type: "ASC" }]
                    },
                    {
                        name: "aquatics",
                        select: ["**"],
                        page: 0,
                        size: 1000000,
                        sort: [{ name: "createDate", type: "ASC" }]
                    },
                    {
                        name: "packages",
                        select: ["**"],
                        page: 0,
                        size: 1000000,
                        sort: [{ name: "createDate", type: "ASC" }]
                    },
                    {
                        name: "tests",
                        select: ["**"],
                        page: 0,
                        size: 1000000,
                        sort: [{ name: "createDate", type: "ASC" }]
                    },
                    {
                        name: "useRates",
                        select: ["**"],
                        page: 0,
                        size: 1000000,
                        sort: [{ name: "createDate", type: "ASC" }]
                    },
                    {
                        name: "distributors",
                        select: ["**", "refDistributor.refPersonType.*"],
                        page: 0,
                        size: 1000000,
                        sort: [{ name: "createDate", type: "ASC" }],
                        children: [
                            {
                                name: "refDistributor.addresses",
                                select: ["*"],
                                page: 0,
                                size: 1,
                                where: [{ name: "refAddressType.key", type: "String", operator: "=", value: "2" }]
                            }
                        ]
                    },
                    {
                        name: "attachments",
                        select: ["*"],
                        page: 0,
                        size: 1000000,
                        sort: [{ name: "createDate", type: "ASC" }]
                    }
                ]
            }
        })
        .then(page => page.data[0]);
};
export const callHazTradeName = ({ tradeNameKey, tradeName, ignoreId }) => {
    const where = [
        { openBucket: true, constant: true, name: "1", type: "String", operator: "=", value: "1" }, // 1
        { name: "isTemp", type: "Boolean", operator: "=", value: false },
        { logic: "OR", openBucket: true, name: "isTemp", type: "Boolean", operator: "=", value: true },
        { closeBucket: true, name: "refLastRequestTemp.refStatus.key", type: "String", operator: "!in", value: ["notApprove", "cancel"] },
        { closeBucket: true, constant: true, name: "1", type: "String", operator: "=", value: "1" }, // 1
        { name: tradeNameKey, type: "String", operator: "=", value: tradeName }
    ];
    if (ignoreId) {
        where.push({ name: "id", type: "UUID", operator: "!=", value: ignoreId });
    }
    return store
        .dispatch("resource/v1/transaction/haz/search", {
            criteria: {
                select: [
                    "id",
                    "version",
                    "approveCode",
                    "approveCode2",
                    "tradeNameTh",
                    "tradeNameEn",
                    "manufacturer",
                    "refUserCompany.id",
                    "refUserCompany.version",
                    "refUserCompany.fullNameTh",
                    "refUserCompany.fullNameEn",
                    "refManufactureCountry.id",
                    "refManufactureCountry.version",
                    "refManufactureCountry.nameTh",
                    "refManufactureCountry.nameEh"
                ],
                page: 0,
                size: 1000000,
                where,
                sort: [{ name: "approveCode", type: "DESC" }]
            }
        })
        .then(page => page.data);
};

export const createColumns = () => {
    const columns = [
        createColumnInput({
            title: () => i18n.global.t("model.haz.refUserCompany"),
            dataIndex: "refHazTemp.refUserCompany.companyNameTh",
            dataIndexValue: ({ record }) =>
                record.refHazTemp?.refUserCompany?.refPersonType?.key === "1"
                    ? record.refHazTemp?.refUserCompany?.companyNameTh
                    : record.refHazTemp?.refUserCompany?.fullNameTh,
            customRender: ({ record, column }) => column.dataIndexValue({ record })
        }),
        createColumnInput({ title: () => i18n.global.t("model.request.draftCode"), dataIndex: "draftCode", align: "center" }),
        createColumnInput({ title: () => i18n.global.t("model.request.requestCode"), dataIndex: "requestCode", align: "center" }),
        // createColumnInput({
        //     title: () => i18n.global.t("views.request.approveCode"),
        //     dataIndex: "refHaz.approveCode2",
        //     align: "center"
        // }),
        // createColumnInput({
        //     title: () => i18n.global.t("model.haz.approveCode"),
        //     dataIndex: "refHaz.approveCode",
        //     align: "center"
        // }),
        createColumnInput({
            title: () => i18n.global.t("views.request.approveCode"),
            dataIndex: "refHazMax.approveCode2",
            align: "center"
        }),
        createColumnInput({
            title: () => i18n.global.t("model.haz.approveCode"),
            dataIndex: "refHazMax.approveCode",
            align: "center"
        }),
        createColumnDatetime({
            title: () => i18n.global.t("views.request.waitReceiveStatusDate"),
            dataIndex: "refWaitReceiveStatus.statusDatetime",
            align: "center"
        }),
        // createColumnDate({
        //     title: () => i18n.global.t("model.haz.effectiveDate"),
        //     dataIndex: "refHaz.effectiveDate",
        //     customRender: ({ record }) => (<>
        //         <div>{ dateFormat({ text: record.refHazNew?.effectiveDate || record.refHaz?.effectiveDate, format: "DD/MM/YYYY" }) }</div>
        //     </>),
        //     customRender2: ({ record }) => (<>
        //         <div className={ record.refHazNew?.effectiveDate ? "line_through" : ""}>
        //             { dateFormat({ text: record.refHaz?.effectiveDate, format: "DD/MM/YYYY" }) }
        //         </div>
        //         <div>{ dateFormat({ text: record.refHazNew?.effectiveDate, format: "DD/MM/YYYY" }) }</div>
        //     </>),
        //     align: "center"
        // }),
        // createColumnDate({
        //     title: () => i18n.global.t("model.haz.expireDate"),
        //     dataIndex: "refHaz.expireDate",
        //     customRender2: ({ record }) => (<>
        //         <div>{dateFormat({
        //             text: record.refHazNew?.expireDate || record.refHaz?.expireDate,
        //             format: "DD/MM/YYYY"
        //         })}</div>
        //     </>),
        //     customRender: ({ record }) => (<>
        //         <div className={record.refHazNew?.expireDate ? "line_through" : ""}>
        //             {dateFormat({ text: record.refHaz?.expireDate, format: "DD/MM/YYYY" })}
        //         </div>
        //         <div>{dateFormat({ text: record.refHazNew?.expireDate, format: "DD/MM/YYYY" })}</div>
        //     </>),
        // }),
        createColumnDate({
            title: () => i18n.global.t("model.haz.effectiveDate"),
            dataIndex: "refHazMax.effectiveDate",
        }),
        createColumnDate({
            title: () => i18n.global.t("model.haz.expireDate"),
            dataIndex: "refHazMax.expireDate",
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.haz.refType"),
            dataIndex: "refHazTemp.refType.value",
            inputProp: () => ({ list: callHazType, optLabel: "value" }),
            search: { name: "refHazTemp.refType.id" }
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.haz.refHazObject"),
            dataIndex: "refHazTemp.refHazObject.nameTh",
            inputProp: () => ({ list: callHazObject, optLabel: "nameTh" }),
            search: { name: "refHazTemp.refHazObject.id" }
        }),
        createColumnInput({
            title: () => i18n.global.t("model.haz.tradeNameTh").replace(" (TH)", ""),
            dataIndex: "refHazTemp.tradeNameTh",
            align: "center"
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.haz.refOperation"),
            dataIndex: "refHazTemp.refOperation.value",
            inputProp: () => ({ list: callUserObjective, optLabel: "value" }),
            search: { name: "refHazTemp.refOperation.id" }
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.request.refRequestType"),
            dataIndex: "refRequestType.value",
            customRender: ({ record }) => (
                <div>
                    <span>{record.refRequestType?.value}</span>
                    {record.isSignCa ? <CIcon class="ml-1" file="sign.svg"></CIcon> : null}
                </div>
            ),
            inputProp: () => ({ list: callRequestType, optLabel: "value" }),
            search: { name: "refRequestType.id" },
            align: "center"
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.request.refStatus"),
            dataIndex: "refStatus.value",
            inputProp: () => ({ list: callRequestStatus, optLabel: "value" }),
            search: { name: "refStatus.id" },
            align: "center"
        })
    ];
    return columns;
};

export const createField = ({ props, data, refs, key }) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    data.onUpdateRefOperation = createOnUpdateRefOperation({ props, data, refs, key });
    return putField({
        data,
        fields: [
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refRequestType`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.request.refRequestType"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refRequestType,
                            "onUpdate:value": value => {
                                const oldValue = model.refRequestType;
                                model.refRequestType = value;
                                model.refHazTemp.effectiveDate = null
                                model.refHazTemp.approveManualDate = null
                                if (
                                    (["2"].includes(oldValue?.key) || (!["1"].includes(oldValue?.key) && ["1"].includes(value?.key))) &&
                                    model.refHaz
                                ) {
                                    Modal.confirm({
                                        title: i18n.global.t("views.request.modal.change", { text: i18n.global.t("model.request.refRequestType") }),
                                        autoFocusButton: "cancel",
                                        onOk: () => {
                                            if (["1", "3"].includes(value?.key)) {
                                                const { createForm } = require("./request.logic");
                                                cloneHaz({
                                                    data,
                                                    model: {
                                                        ...createForm({ props, data, refs }),
                                                        id: model.id,
                                                        version: model.version,
                                                        isActive: model.isActive,
                                                        refStatus: model.refStatus,
                                                        refRequestDoc: model.refRequestDoc,
                                                        draftCode: model.draftCode,
                                                        requestCode: model.requestCode
                                                    }
                                                });
                                            } else {
                                                cloneHaz({ data, model, id: model.refHaz?.id });
                                            }
                                        },
                                        onCancel: () => {
                                            model.refRequestType = oldValue;
                                        }
                                    });
                                }
                            },
                            disabled: viewOnly,
                            list: callRequestType,
                            optLabel: "value",
                            allowClear: false
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refHaz`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.storageLocation.approveCode"),
                inputProp: ({ field }) => {
                    return lodash.merge(
                        {
                            value: model.refHaz,
                            "onUpdate:value": value => {
                                const oldValue = model.refHaz;
                                model.refHaz = value;
                                if (oldValue) {
                                    Modal.confirm({
                                        title: i18n.global.t("views.request.modal.change", {
                                            text: i18n.global.t("model.storageLocation.approveCode")
                                        }),
                                        autoFocusButton: "cancel",
                                        onOk: () => cloneHaz({ data, model, id: value?.id }),
                                        onCancel: () => {
                                            model.refHaz = oldValue;
                                        }
                                    });
                                } else {
                                    cloneHaz({ data, model, id: value?.id });
                                }
                            },
                            disabled: viewOnly,
                            list: ({ searchQuery }) =>
                                callHaz({
                                    searchQuery,
                                    userInfo: store.state.resource.auth.info?.user,
                                    isOfficerCreate: model.isOfficerCreate,
                                    requestDocKey: model.refRequestDoc?.key,
                                    requestTypeKey: model.refRequestType?.key,
                                    expireDate:
                                        model.refRequestDoc?.key && model.refRequestType?.key === "3"
                                            ? moment()
                                                  .add(model.refRequestDoc.attribute.renew, model.refRequestDoc.attribute.renewUnit)
                                                  .format("YYYY-MM-DD")
                                            : null
                                }).then((res) => {
                                    // loop for check disabled item
                                    if (model.refRequestType?.key === "3") {
                                        res.forEach(d => d.disabled = d.expireDate && moment(moment().format("YYYY-MM-DD")).isAfter(moment(d.expireDate)));
                                    }
                                    // console.log("callHaz", res);
                                    if (model.refRequestType?.key !== "3") {
                                        return res;
                                    }
                                    let promise = callFilterHazDataExpired({ data: res });
                                    return promise.then(d => d);
                                }),
                            renderLabel: ({ item }) => {
                                const expire = item.expireDate ? ` (Expire: ${dateFormat({ text: item.expireDate, format: "DD/MM/YYYY" })})` : ''
                                return <div>{item.approveCode}{expire} - {item.refUserCompany?.fullNameTh}</div>;
                            },
                            allowClear: false
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    );
                },
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refHazTemp.refOperation`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.haz.refOperation"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refHazTemp.refOperation,
                            "onUpdate:value": data.onUpdateRefOperation,
                            disabled: viewOnly || !model.refHazTemp.refUserCompany,
                            list: ({ searchQuery }) =>
                                callUserObjective({ searchQuery }).then(items =>
                                    checkUserCompanyOperation({ operations: items, userCompany: model.refHazTemp.refUserCompany })
                                ),
                            optLabel: "value",
                            allowClear: false
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldInput({
                visible: ({ field }) => model.requestCode && conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}requestCodeTitle`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.request.requestCode"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.requestCode,
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => model.refHaz?.approveCode2 && conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refHaz.approveCode2`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.request.approveCode"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refHaz?.approveCode2,
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => model.refHaz?.approveCode && conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refHaz.approveCode`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.haz.approveCode"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refHaz?.approveCode,
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldDate({
                visible: ({ field }) => ((model.refDocGenType?.key === "2" && model.refRequestType?.key === "1") || model.refHaz?.effectiveDate) && conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refHazTemp.effectiveDate`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("views.request.effectiveDate"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refHazTemp?.effectiveDate,
                            "onUpdate:value": value => (model.refHazTemp.effectiveDate = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldDate({
                visible: ({ field }) => ((model.refDocGenType?.key === "2" && model.refRequestType?.key === "1") || model.refHaz?.approveManualDate) && conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refHazTemp.approveManualDate`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.haz.approveManualDate"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refHazTemp?.approveManualDate,
                            "onUpdate:value": value => {
                                model.refHazTemp.approveManualDate = value
                            },
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldDate({
                visible: ({ field }) => (model.refHaz?.expireDate) && conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refHaz.expireDate`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("views.request.expireDate"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refHazTemp?.expireDate || model.refHaz?.expireDate,
                            "onUpdate:value": value => (model.refHazTemp.expireDate = value),
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}lastStatus.forRequestRemark.0.remark`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.request.descToOfficer"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.lastStatus.forRequestRemark?.[0]?.remark,
                            "onUpdate:value": value => (model.lastStatus.forRequestRemark[0].remark = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}lastStatus.forReceiveRemark.0.remark`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.request.descToUserCompany"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.lastStatus.forReceiveRemark?.[0]?.remark,
                            "onUpdate:value": value => (model.lastStatus.forReceiveRemark[0].remark = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            })
        ]
    });
};

export const cloneHaz = ({ data, model, id }) => {
    if (id) {
        setIsLoadingApp(true);
        callHazFull({ id })
            .then(haz => {
                const refHazTemp = copyForm({ form: { ...haz, isTemp: true } });
                if (id) {
                    refHazTemp.attachments.forEach((d, index) => (d.refRealId = haz.attachments[index].id));
                    refHazTemp.products.forEach((d, index) => (d.refReal = { id: haz.products[index].id }));
                    refHazTemp.mainSubStances.forEach((d, index) => {
                        d.refReal = { id: haz.mainSubStances[index].id };
                        d.companies.forEach((d2, index2) => (d2.refReal = { id: haz.mainSubStances[index].companies[index2].id }));
                        d.products.forEach((d2, index2) => (d2.refReal = { id: haz.mainSubStances[index].products[index2].id }));
                        d.attachments.forEach((d2, index2) => (d2.refRealId = haz.mainSubStances[index].attachments[index2].id));
                    });
                    refHazTemp.pictograms.forEach((d, index) => (d.refReal = { id: haz.pictograms[index].id }));
                    refHazTemp.aquatics.forEach((d, index) => (d.refReal = { id: haz.aquatics[index].id }));
                    refHazTemp.packages.forEach((d, index) => (d.refReal = { id: haz.packages[index].id }));
                    refHazTemp.tests.forEach((d, index) => (d.refReal = { id: haz.tests[index].id }));
                    refHazTemp.useRates.forEach((d, index) => (d.refReal = { id: haz.useRates[index].id }));
                    refHazTemp.distributors.forEach((d, index) => (d.refReal = { id: haz.distributors[index].id }));
                }
                return callUser({ userCompanyId: refHazTemp.refUserCompany.id }).then(users => {
                    refHazTemp.refUser = users.find(d => d.id === store.state.resource.auth.info?.user?.id) || refHazTemp.refUser;
                    router.push({
                        name: router.currentRoute.value.name,
                        params: {
                            props: JSON.stringify({
                                form: {
                                    ...model,
                                    refRequestDoc: getRequestDoc({ data, refOperation: refHazTemp.refOperation }),
                                    refDepartment: haz.refDepartment,
                                    refHazTemp
                                }
                            })
                        },
                        query: { _timestamp: new Date().getTime() }
                    });
                });
            })
            .finally(() => setIsLoadingApp(false));
    } else {
        router.push({
            name: router.currentRoute.value.name,
            params: { props: JSON.stringify({ forceDefault: true, form: model }) },
            query: { _timestamp: new Date().getTime() }
        });
    }
};

export const isOperationAndSubStanceTypeMain = ({ modelRef, operation, subStanceTypeMain, isTechnicalGrade }) => {
    return (
        modelRef.refHazTemp.refOperation?.key === operation &&
        modelRef.refHazTemp.refSubStanceTypeMain?.key === subStanceTypeMain &&
        (isTechnicalGrade ? modelRef.refHazTemp.isTechnicalGrade : !modelRef.refHazTemp.isTechnicalGrade)
    );
};

export const requiredSolidOrLiquid = ({ data, key }) => {
    return {
        validator: () => {
            const modelRef = data.useForm?.modelRef || data.form;
            const model = key ? lodash.get(modelRef, key) : modelRef;
            if (model.refHazTemp.isSolid !== true && model.refHazTemp.isLiquid !== true) {
                return Promise.reject(i18n.global.t("views.request.hazInfo.error.isSolidOrIsLiquid"));
            }
            return Promise.resolve();
        },
        trigger: "change"
    };
};

export const createOnUpdateRefOperation = ({ data, key }) => {
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    return value => {
        model.refHazTemp.refOperation = value;
        clearSubStanceMain({ modelRef, model: model.refHazTemp });
        if (value) {
            model.refRequestDoc = getRequestDoc({ data, refOperation: value });
            if (value.key === "4") {
                model.refHazTemp.refType = data.hazTypes.find(d => d.key === "2");
                callCountry({}).then(countries => (model.refHazTemp.refManufactureCountry = countries.find(d => d.nameEnS === "TH")));
            }
        } else {
            model.refRequestDoc = null;
        }
    };
};

const getRequestDoc = ({ data, refOperation }) => {
    return data.requestDocs.find(item => {
        if ((refOperation.key === "1" && item.key === "04") || (refOperation.key === "4" && item.key === "05")) {
            return item;
        }
    });
};

export const hazReserveWordRule = ({ data, key, valueKey }) => {
    return {
        validator: (rule, value) => {
            const { useForm } = data;
            const { modelRef } = useForm;
            const model = key ? lodash.get(modelRef, key) : modelRef;
            if (
                !["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"].includes(
                    modelRef.refStatus?.key
                )
            ) {
                if (value) {
                    const found = data.hazReserveWords.some(d => {
                        const words =
                            lodash
                                .get(d, valueKey)
                                ?.split(",")
                                .filter(d => d) || [];
                        const mainSubStanceTypes = d.attribute?.mainSubStanceType || [];
                        if (mainSubStanceTypes.length > 0) {
                            if (!mainSubStanceTypes.includes(model.refSubStanceTypeMain?.key)) {
                                return false;
                            }
                        }
                        return words.some(d => value.toLowerCase().includes(d.toLowerCase()));
                    });
                    if (found) {
                        return Promise.reject(i18n.global.t("views.request.hazInfo.error.reserveWord"));
                    }
                }
            }
            return Promise.resolve();
        },
        trigger: "change"
    };
};

export const hazDuplicateWordRule = ({ data, key, tradeNameKey }) => {
    return {
        validator: (rule, value) => {
            const { useForm } = data;
            const { modelRef } = useForm; // request
            const model = key ? lodash.get(modelRef, key) : modelRef; // haz
            if (
                !["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove", "cancel"].includes(
                    modelRef.refStatus?.key
                )
            ) {
                if (modelRef.refRequestType?.key === "1" && model.refType?.key != "1" && value) {
                    return callHazTradeName({ tradeNameKey, tradeName: value, ignoreId: model.id }).then(hazes => {
                        if (hazes.length > 0) {
                            const isOtherCompany = hazes.some(d => d.refUserCompany.id !== model.refUserCompany?.id);
                            if (isOtherCompany) {
                                return Promise.reject(i18n.global.t("views.request.hazInfo.error.tradeNameDuplicateOther"));
                            }
                            const isSameManufacturer = hazes.some(d => d.manufacturer === model.manufacturer);
                            const isSameManufactureCountry = hazes.some(
                                d => d.refManufactureCountry.id === model.refManufactureCountry?.id
                            );
                            if (isSameManufacturer && isSameManufactureCountry) {
                                return Promise.reject(i18n.global.t("views.request.hazInfo.error.tradeNameDuplicate"));
                            }
                        }
                        return Promise.resolve();
                    });
                }
            }
            return Promise.resolve();
        },
        trigger: "blur"
    };
};
